"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _withStyles = _interopRequireDefault(require("elevate-ui/withStyles"));

var _Typography = _interopRequireDefault(require("elevate-ui/Typography"));

var _ = require("../..");

var ComponentPreview = function ComponentPreview(_ref) {
  var activeComponent = _ref.activeComponent,
      classes = _ref.classes,
      internals = _ref.internals;

  if (activeComponent) {
    var content = null;

    if (activeComponent.generateContent) {
      content = activeComponent.generateContent();
    }

    if (!Array.isArray(content) && content) {
      content = [content];
    }

    return /*#__PURE__*/_react["default"].createElement("div", {
      className: classes.root
    }, /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
      type: "heading6",
      gutterBottom: true
    }, activeComponent.label || activeComponent.type, " Preview"), /*#__PURE__*/_react["default"].createElement("div", {
      className: classes.content
    }, content ? _.Tools.renderReact({
      content: content,
      components: internals.components,
      previewPlaceholders: true
    }) : null), /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
      type: "body",
      gutterTop: true
    }, activeComponent && activeComponent.description));
  } else {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _classnames["default"])(classes.root, classes.noSelection)
    }, /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
      type: "body"
    }, "Select a component you would like to add from the sidebar."));
  }
};

var styles = function styles(theme) {
  return {
    root: (0, _defineProperty2["default"])({
      position: "relative",
      display: "none",
      flexDirection: "column",
      alignItems: "center",
      overflowY: "scroll",
      padding: "20px",
      maxHeight: "100%"
    }, theme.breakpoints(900), {
      display: "flex",
      minWidth: "460px",
      flex: "0 0 460px"
    }),
    preview: {
      width: "100%",
      display: "flex",
      justifyContent: "center",
      padding: "20px 0",
      border: "1px dotted #ddd"
    },
    previewImage: {
      maxWidth: "100%",
      height: "auto"
    },
    noSelection: {
      justifyContent: "center",
      textAlign: "center",
      minHeight: "100%"
    }
  };
};

var _default = (0, _withStyles["default"])(styles, {
  name: "ComponentPreview"
})(ComponentPreview);

exports["default"] = _default;